import axios from "axios";

const updateZoneDisplays= (data) => { 

  let jwt = localStorage.getItem('JWT')
  let link = localStorage.getItem('link')

        axios.put(link+'/api/'+data.Type+'/ArrowElementMode?elementId='+data.Id+'&arrowElement='+data.ArrowElement+'&mode='+data.Mode, {
 
          headers: {
            Authorization:'Bearer ' + jwt
         }
        
        })  .then((response) => {         
          // updateSvg()
        });

  
   //multiple ids

   //
 

}


export default (updateZoneDisplays);
